import Image from 'next/image'
import { nextImageHelper } from '../../utils'

export const HowBTWorks: React.FC = () => {
  return (
    <div className="c-howbt / bg-blue-50 rounded-sm / mt-6 mb-8 / pt-4 pb-1 md:pb-3 px-2">
      <div className="c-howbt__title-wrap / flex items-start sm:justify-center / w-full">
        <div className="c-howbt__title-icon / shrink-0 / inline-block w-7 md:w-8">
          <Image
            alt="checkmark circle"
            src="/static/icons/checkmark-circle.svg"
            height={36}
            width={36}
            aria-hidden={true}
            style={nextImageHelper.responsive}
          />
        </div>
        <h2 className="c-howbt__title / text-xl md:text-2xl font-bold text-primary mb-2 pl-2 / leading-tight">
          How a Balance transfer works (3 simple steps):
        </h2>
      </div>
      <ul className="c-howbt__list / grid grid-cols-1 sm:grid-cols-3 font-semibold text-primary text-left text-sm sm:text-fs13 lg:text-sm / leading-snug">
        <li className="c-howbt__item c-howbt__item--border / flex items-center sm:items-start justify-start / w-full / py-2 sm:px-2 lg:px-3">
          <div className="c-howbt__item-icon / shrink-0 / flex justify-center items-center w-8">
            <Image
              alt="how balance transfer works card"
              src="/static/icons/how-balance-transfer-works-card.svg"
              height={36}
              width={36}
              aria-hidden={true}
              style={nextImageHelper.responsive}
              sizes="100vw"
            />
          </div>
          <div className="c-howbt__item-content / pl-2">
            Get Approved & Transfer your&nbsp;Balance
          </div>
        </li>
        <li className="c-howbt__item c-howbt__item--border / flex items-center sm:items-start justify-start / w-full / py-2 sm:px-2 lg:px-3">
          <div className="c-howbt__item-icon / shrink-0 / flex justify-center items-center w-8">
            <Image
              alt="how balance transfer works percent"
              src="/static/icons/how-balance-transfer-works-percent.svg"
              height={36}
              width={36}
              aria-hidden={true}
              style={nextImageHelper.responsive}
              sizes="100vw"
            />
          </div>
          <div className="c-howbt__item-content / pl-2">
            Press Pause on Interest&nbsp;Payments
          </div>
        </li>
        <li className="c-howbt__item / flex items-center sm:items-start justify-start / w-full / py-2 sm:px-2 lg:px-3">
          <div className="c-howbt__item-icon / shrink-0 / flex justify-center items-center w-8">
            <Image
              alt="how balance transfer works face"
              src="/static/icons/how-balance-transfer-works-face.svg"
              height={36}
              width={36}
              aria-hidden={true}
              style={nextImageHelper.intrinsic}
              sizes="100vw"
            />
          </div>
          <div className="c-howbt__item-content / pl-2">
            Breathe Easier as You Pay Down&nbsp;Debt
          </div>
        </li>
      </ul>
      <style jsx>{`
        .c-howbt__item--border {
          border-image-slice: 1;
          border-width: 1px;

          border-image-source: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.15) 35%,
            rgba(0, 0, 0, 0.15) 65%,
            rgba(0, 0, 0, 0) 100%
          );
          border-top: 0;
        }
        @media (min-width: 640px) {
          .c-howbt__item--border {
            border-image-slice: 1;
            border-width: 1px;

            border-image-source: linear-gradient(
              to top,
              rgba(0, 0, 0, 0) 0%,
              rgba(0, 0, 0, 0.15) 35%,
              rgba(0, 0, 0, 0.15) 65%,
              rgba(0, 0, 0, 0) 100%
            );
            border-left: 0;
          }
        }
      `}</style>
    </div>
  )
}
